import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import ErrorBoundary from './ErrorBoundary.jsx'
import { initErrorReporting } from './errorReporting'
import LegalPage from './LegalPage.jsx'
import { getLegalPageByPath } from './legalPages.js'

initErrorReporting()

const legalPath = window.location.pathname.replace(/\/+$/, '') || '/'
const legalPage = getLegalPageByPath(legalPath)

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      {legalPage ? <LegalPage page={legalPage} /> : <App />}
    </ErrorBoundary>
  </StrictMode>,
)
